var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      ref: "drawer",
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_LoadingPool"),
        visible: _vm.innerVisible,
        size: "50%",
        "custom-class": "setting-and-tools-drawer",
        modal: false,
        "append-to-body": ""
      },
      on: { close: _vm.handleClose }
    },
    [
      _vm.innerVisible
        ? _c("load-pool", {
            staticStyle: { height: "100%" },
            attrs: {
              "airline-product-down-list": _vm.airlineProductDownList,
              source: _vm.SystemConstants.LOAD_POOL_SOURCE_DETAIL.code
            },
            on: { addUldItemsToUld: _vm.addUldItemsToUld }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }